import { Component, OnInit, OnDestroy, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { faCalendarAlt } from '@fortawesome/free-regular-svg-icons';
import { BasicInformationsService } from '../shared/services/basic-informations.service';
import { BasicInformations } from '../shared/models/basic-informations.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { InsuranceSumAndPremium } from '../shared/models/insurance-sum-and-premium.model';
import { SendingSumAndPremiumInfoService } from '../shared/services/sending-sum-and-premium-info.service';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import { SaveDraftService } from '../shared/services/save-draft.service';
import { Subscription } from 'rxjs';
import { DigitalService } from '../shared/services/digital.service';
import { RemoveInfoService } from '../shared/services/remove-info.service';
import { FillDraftOfferService } from '../shared/services/fill-draft.service';
import { SendInfoService } from '../shared/services/send-info.service';

@Component({
  selector: 'app-general-calculator',
  templateUrl: './general-calculator.component.html',
  styleUrls: ['./general-calculator.component.sass']
})
export class GeneralCalculatorComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('contracotrBlock', { static: false }) private contracotrBlock: ElementRef;
  @ViewChild('insuredBlock', { static: false }) private insuredBlock: ElementRef;

  @Output() dateSelect = new EventEmitter<NgbDateStruct>();
  faCalendarAlt = faCalendarAlt;

  title: String = "";
  infoText: String = "";
  boolInfoText: Boolean = true;

  contractorBool: Boolean = false;
  insuredBool: Boolean = false;
  validDraft: Boolean = false;
  validDigital: Boolean = false;

  saveDraftSubscription: Subscription;
  digitalSubscription: Subscription;
  removeInto: Subscription;
  fillDraftSubscription: Subscription;
  sendInfoSubscription: Subscription;

  // Forma za Ugovaraca osiguranja
  insuranceContractorForm = new FormGroup({
    responsiblePerson: new FormControl('2', [Validators.required]),
    firstname: new FormControl('', [Validators.required]),
    lastname: new FormControl('', [Validators.required]),
    responsiblePersonFirstname: new FormControl('', [Validators.required]),
    responsiblePersonLastname: new FormControl('', [Validators.required]),
    legalEntityName: new FormControl('', [Validators.required]),
    jmbg: new FormControl('', [Validators.required]),
    idLegal: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required]),
    address: new FormControl('', [Validators.required]),
    pib: new FormControl('', [Validators.required]),
    settlement: new FormControl('', [Validators.required]),
    postalCode: new FormControl('', [Validators.required]),
    mobile: new FormControl('', [Validators.required, Validators.pattern('0[0-9]{7,9}')]),
    addressOfDelivery: new FormControl('', [Validators.required]),
    postalCodeOfDelivery: new FormControl('', [Validators.required]),
    settlementOfDelivery: new FormControl('', [Validators.required]),
    contractorIsInsured: new FormControl(false, []),
    copyToDelivery: new FormControl(false, [])
  })

  // Forma za Osiguranika
  insuredForm = new FormGroup({
    firstname: new FormControl('', [Validators.required]),
    lastname: new FormControl('', [Validators.required]),
    address: new FormControl('', [Validators.required]),
    dob: new FormControl({ value: '', disabled: true }),
    postalCode: new FormControl('', [Validators.required]),
    settlement: new FormControl('', [Validators.required]),
    jmbg: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.pattern(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)]),
    job: new FormControl('', [Validators.required]),
    mobile: new FormControl('', [Validators.required, Validators.pattern('0[0-9]{7,9}')])
  })

  routerUrl;


  constructor(private router: Router, private basicInformationsService: BasicInformationsService, private sendingSumAndPremiumInfo: SendingSumAndPremiumInfoService, private saveDraftService: SaveDraftService, private digitalService: DigitalService, private removeInfoService: RemoveInfoService, private fillDraftOfferService: FillDraftOfferService, private sendInfoService: SendInfoService) {
    this.sendInfoSubscription = sendInfoService.info$.subscribe(
      (x: Boolean) => {
        if (x)
          this.insurendSendInfo();
      }
    )
    this.removeInto = this.removeInfoService.info$.subscribe(
      (x: Boolean) => {
        if (x) {
          this.contractorBool = false;
          this.insuredBool = false;
          this.validDigital = false;
          this.validDraft = false;
          this.insuranceContractorForm.reset({ contractorIsInsured: false, copyToDelivery: false, responsiblePerson: '2' })
          this.insuredForm.reset()
          this.removeInfoService.sendOfferID(false);
        } else {

        }
      }
    )
    this.saveDraftSubscription = saveDraftService.info$.subscribe(
      (res) => {
        if (!this.insuranceContractorForm.value.name) {
          this.contractorBool = true;
        }
        if (res) {
          Object.keys(this.insuranceContractorForm.controls).forEach(field => {
            const control = this.insuranceContractorForm.get(field);
            control.markAsTouched({ onlySelf: true });
          });
          this.validDraft = true;
          this.validDigital = false;
          console.log(this.contracotrBlock)
          if (this.contracotrBlock)
            this.contracotrBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
        } else {
          // console.log("Open link")
        }
      }
    )

    this.fillDraftSubscription = fillDraftOfferService.info$.subscribe(
      (res: any) => {
        if (res) {
          if (res.contractor.clientType == 0) {
            this.insuranceContractorForm.get('responsiblePerson').setValue('2')
            this.insuranceContractorForm.get('firstname').setValue(res.contractor.firstname)
            this.insuranceContractorForm.get('lastname').setValue(res.contractor.lastname)
          }
          if (res.contractor.clientType == 1) {
            this.insuranceContractorForm.get('responsiblePerson').setValue('1')
            this.insuranceContractorForm.get('responsiblePersonFirstname').setValue(res.contractor.firstname)
            this.insuranceContractorForm.get('responsiblePersonLastname').setValue(res.contractor.lastname)
            this.insuranceContractorForm.get('legalEntityName').setValue(res.contractor.companyName)
            this.insuranceContractorForm.get('idLegal').setValue(res.contractor.companyID)
            this.insuranceContractorForm.get('pib').setValue(res.contractor.taxID)
          }
          this.insuranceContractorForm.get('jmbg').setValue(res.contractor.jmbg)
          this.insuranceContractorForm.get('mobile').setValue(res.contractor.mobile)
          this.insuranceContractorForm.get('email').setValue(res.contractor.email)
          this.insuranceContractorForm.get('address').setValue(res.contractor.address)
          this.insuranceContractorForm.get('postalCode').setValue(res.contractor.postalCode)
          this.insuranceContractorForm.get('settlement').setValue(res.contractor.settlement)
          this.insuranceContractorForm.get('addressOfDelivery').setValue(res.contractor.deliveryAddress)
          this.insuranceContractorForm.get('postalCodeOfDelivery').setValue(res.contractor.deliveryPostalCode)
          this.insuranceContractorForm.get('settlementOfDelivery').setValue(res.contractor.deliverySettlement)

          if (res.contractor.address == res.contractor.deliveryAddress && res.contractor.postalCode == res.contractor.deliveryPostalCode && res.contractor.settlement == res.contractor.deliverySettlement) {
            this.insuranceContractorForm.get('copyToDelivery').setValue(true)
          }

          this.insuranceContractorForm.get('contractorIsInsured').setValue(res.contractorIsInsuree)

          this.insuredForm.get('firstname').setValue(res.insuree.firstname)
          this.insuredForm.get('lastname').setValue(res.insuree.lastname)
          this.insuredForm.get('jmbg').setValue(res.insuree.jmbg)
          this.insuredForm.get('job').setValue(res.insuree.occupation)
          this.insuredForm.get('email').setValue(res.insuree.email)
          this.insuredForm.get('mobile').setValue(res.insuree.mobile)
          this.insuredForm.get('address').setValue(res.insuree.address)
          this.insuredForm.get('postalCode').setValue(res.insuree.postalCode)
          this.insuredForm.get('settlement').setValue(res.insuree.settlement)

          this.insurendSendInfo();
          this.fillDraftOfferService.sendDraft(false)
        }
      }
    )

  }

  ngOnInit() {
    this.contractorBool = false;
    this.routerUrl = this.router.url;
    // console.log(this.routerUrl)
    if (this.router.url == '/sava/calculator/standard-calculation-insured-sum') {
      this.title = "Obračun osigurane sume na osnovu premije";
      this.infoText = "Informativna ponuda za mešovito osiguranje života i mešovito osiguranje života sa pokrićem težih bolesti";
      this.boolInfoText = true;
      this.insuredForm.get('job').setValidators([Validators.required]);
      this.insuredForm.get('job').updateValueAndValidity();
    } else if (this.router.url == '/sava/calculator/standard-calculation-premium') {
      this.title = "Obračun premije na osnovu osigurane sume";
      this.infoText = "Informativna ponuda za mešovito osiguranje života i mešovito osiguranje života sa pokrićem težih bolesti";
      this.boolInfoText = true;
      this.insuredForm.get('job').setValidators([Validators.required]);
      this.insuredForm.get('job').updateValueAndValidity();
    } else if (this.router.url == '/sava/calculator/adut-calculation-insured-sum') {
      this.title = "Obračun osigurane sume na osnovu premije";
      this.infoText = "Informativna ponuda za osiguranje života za slučaj doživljenja i isplatom premija za slučaj smrti";
      this.boolInfoText = true;
      this.insuredForm.get('job').setValidators([Validators.required]);
      this.insuredForm.get('job').updateValueAndValidity();
    } else if (this.router.url == '/sava/calculator/adut-calculation-premium') {
      this.title = "Obračun premije na osnovu osigurane sume";
      this.infoText = "Informativna ponuda za osiguranje života za slučaj doživljenja i isplatom premija za slučaj smrti";
      this.boolInfoText = true;
      this.insuredForm.get('job').setValidators([Validators.required]);
      this.insuredForm.get('job').updateValueAndValidity();
    } else if (this.router.url == '/sava/calculator/security-calculation-insured-sum') {
      this.title = "Obračun osigurane sume na osnovu premije";
      this.infoText = "Informativna ponuda za osiguranje života za slučaj smrti";
      this.boolInfoText = true;
      this.insuredForm.get('job').setValidators([Validators.required]);
      this.insuredForm.get('job').updateValueAndValidity();
    } else if (this.router.url == '/sava/calculator/security-calculation-premium') {
      this.title = "Obračun premije na osnovu osigurane sume";
      this.infoText = "Informativna ponuda za osiguranje života za slučaj smrti";
      this.boolInfoText = true;
      this.insuredForm.get('job').setValidators([Validators.required]);
      this.insuredForm.get('job').updateValueAndValidity();
    } else if (this.router.url == '/sava/calculator/security-credit') {
      this.title = "Obračun premije na osnovu osigurane sume";
      this.infoText = "Informativna ponuda za individualno osiguranje života sa opadajućom osiguranom sumom";
      this.boolInfoText = true;
      this.insuredForm.get('job').setValidators([Validators.required]);
      this.insuredForm.get('job').updateValueAndValidity();
    } else if (this.router.url == '/sava/calculator/scholarship-calculation-insured-sum') {
      this.title = "Obračun osigurane sume na osnovu premije";
      this.infoText = "Informativna ponuda za stipendijsko osiguranje života";
      this.boolInfoText = true;
      this.insuredForm.get('job').setValidators([Validators.required]);
      this.insuredForm.get('job').updateValueAndValidity();
    } else if (this.router.url == '/sava/calculator/scholarship-calculation-premium') {
      this.title = "Obračun premije na osnovu osigurane sume";
      this.infoText = "Informativna ponuda za stipendijsko osiguranje života";
      this.boolInfoText = true;
      this.insuredForm.get('job').setValidators([Validators.required]);
      this.insuredForm.get('job').updateValueAndValidity();
    } else if (this.router.url == '/sava/calculator/golden-autumn') {
      this.title = "Informativna ponuda za osiguranje života za slučaj smrti";
      this.infoText = "";
      this.boolInfoText = false;
      this.insuredForm.get('job').clearValidators();
      this.insuredForm.get('job').updateValueAndValidity();
    } else if (this.router.url == '/sava/calculator/naj-life-calculation-insured-sum') {
      this.title = "Obračun osigurane sume na osnovu premije";
      this.infoText = "Informativna ponuda za naj life osiguranje života";
      this.boolInfoText = true;
      this.insuredForm.get('job').setValidators([Validators.required]);
      this.insuredForm.get('job').updateValueAndValidity();
    } else if (this.router.url == '/sava/calculator/naj-life-calculation-premium') {
      this.title = "Obračun premije na osnovu osigurane sume";
      this.infoText = "Informativna ponuda za naj life osiguranje života";
      this.boolInfoText = true;
      this.insuredForm.get('job').setValidators([Validators.required]);
      this.insuredForm.get('job').updateValueAndValidity();
    } else if (this.router.url == '/sava/calculator/progresive') {
      this.title = "SAVA PROGRESIV";
      this.infoText = "Informativna ponuda za osiguranje života za slučaj  smrti i doživljenja vezano za jedinice investicionih fondova";
      this.boolInfoText = true;
      this.insuredForm.get('job').setValidators([Validators.required]);
      this.insuredForm.get('job').updateValueAndValidity();
    } else if (this.router.url == '/sava/calculator/security-cash') {
      this.title = "Obračun premije na osnovu osigurane sume";
      this.infoText = "Informativna ponuda za individualno osiguranje života sa opadajućom osiguranom sumom - Gotovinski krediti";
      this.boolInfoText = true;
      this.insuredForm.get('job').setValidators([Validators.required]);
      this.insuredForm.get('job').updateValueAndValidity();
    } else if (this.router.url == '/sava/calculator/vip-standard-insurance-sum') {
      this.title = "Obračun osigurane sume na osnovu premije";
      this.infoText = "Informativna ponuda za mešovito osiguranje života i mešovito osiguranje života sa pokrićem težih bolesti";
      this.boolInfoText = true;
      this.insuredForm.get('job').setValidators([Validators.required]);
      this.insuredForm.get('job').updateValueAndValidity();
    } else if (this.router.url == '/sava/calculator/vip-standard-premium') {
      this.title = "Obračun premije na osnovu osigurane sume";
      this.infoText = "Informativna ponuda za mešovito osiguranje života i mešovito osiguranje života sa pokrićem težih bolesti";
      this.boolInfoText = true;
      this.insuredForm.get('job').setValidators([Validators.required]);
      this.insuredForm.get('job').updateValueAndValidity();
    } else if (this.router.url == '/sava/calculator/vip-security-insurance-sum') {
      this.title = "Obračun osigurane sume na osnovu premije";
      this.infoText = "Informativna ponuda za osiguranje života za slučaj smrti";
      this.boolInfoText = true;
      this.insuredForm.get('job').setValidators([Validators.required]);
      this.insuredForm.get('job').updateValueAndValidity();
    } else if (this.router.url == '/sava/calculator/vip-security-premium') {
      this.title = "Obračun premije na osnovu osigurane sume";
      this.infoText = "Informativna ponuda za osiguranje života za slučaj smrti";
      this.boolInfoText = true;
      this.insuredForm.get('job').setValidators([Validators.required]);
      this.insuredForm.get('job').updateValueAndValidity();
    } else if (this.router.url == '/sava/calculator/vip-scholarship-insurance-sum') {
      this.title = "Obračun osigurane sume na osnovu premije";
      this.infoText = "Informativna ponuda za stipendijsko osiguranje života";
      this.boolInfoText = true;
      this.insuredForm.get('job').setValidators([Validators.required]);
      this.insuredForm.get('job').updateValueAndValidity();
    } else if (this.router.url == '/sava/calculator/vip-scholarship-premium') {
      this.title = "Obračun premije na osnovu osigurane sume";
      this.infoText = "Informativna ponuda za stipendijsko osiguranje života";
      this.boolInfoText = true;
      this.insuredForm.get('job').setValidators([Validators.required]);
      this.insuredForm.get('job').updateValueAndValidity();
    }
    this.router.events
      .subscribe((val) => {
        if (val instanceof NavigationEnd) {
          this.routerUrl = this.router.url;
          if (val.url == '/sava/calculator/standard-calculation-insured-sum') {
            this.title = "Obračun osigurane sume na osnovu premije";
            this.infoText = "Informativna ponuda za mešovito osiguranje života i mešovito osiguranje života sa pokrićem težih bolesti";
            this.boolInfoText = true;
            this.insuredForm.get('job').setValidators([Validators.required]);
            this.insuredForm.get('job').updateValueAndValidity();
          } else if (val.url == '/sava/calculator/standard-calculation-premium') {
            this.title = "Obračun premije na osnovu osigurane sume";
            this.infoText = "Informativna ponuda za mešovito osiguranje života i mešovito osiguranje života sa pokrićem težih bolesti";
            this.boolInfoText = true;
            this.insuredForm.get('job').setValidators([Validators.required]);
            this.insuredForm.get('job').updateValueAndValidity();
          } else if (val.url == '/sava/calculator/adut-calculation-insured-sum') {
            this.title = "Obračun osigurane sume na osnovu premije";
            this.infoText = "Informativna ponuda za osiguranje života za slučaj doživljenja i isplatom premija za slučaj smrti";
            this.boolInfoText = true;
            this.insuredForm.get('job').setValidators([Validators.required]);
            this.insuredForm.get('job').updateValueAndValidity();
          } else if (val.url == '/sava/calculator/adut-calculation-premium') {
            this.title = "Obračun premije na osnovu osigurane sume";
            this.infoText = "Informativna ponuda za osiguranje života za slučaj doživljenja i isplatom premija za slučaj smrti";
            this.boolInfoText = true;
            this.insuredForm.get('job').setValidators([Validators.required]);
            this.insuredForm.get('job').updateValueAndValidity();
          } else if (val.url == '/sava/calculator/security-calculation-insured-sum') {
            this.title = "Obračun osigurane sume na osnovu premije";
            this.infoText = "Informativna ponuda za osiguranje života za slučaj smrti";
            this.boolInfoText = true;
            this.insuredForm.get('job').setValidators([Validators.required]);
            this.insuredForm.get('job').updateValueAndValidity();
          } else if (val.url == '/sava/calculator/security-calculation-premium') {
            this.title = "Obračun premije na osnovu osigurane sume";
            this.infoText = "Informativna ponuda za osiguranje života za slučaj smrti";
            this.boolInfoText = true;
            this.insuredForm.get('job').setValidators([Validators.required]);
            this.insuredForm.get('job').updateValueAndValidity();
          } else if (val.url == '/sava/calculator/security-credit') {
            this.title = "Obračun premije na osnovu osigurane sume";
            this.infoText = "Informativna ponuda za individualno osiguranje života sa opadajućom osiguranom sumom";
            this.boolInfoText = true;
            this.insuredForm.get('job').setValidators([Validators.required]);
            this.insuredForm.get('job').updateValueAndValidity();
          } else if (val.url == '/sava/calculator/scholarship-calculation-insured-sum') {
            this.title = "Obračun osigurane sume na osnovu premije";
            this.infoText = "Informativna ponuda za stipendijsko osiguranje života";
            this.boolInfoText = true;
            this.insuredForm.get('job').setValidators([Validators.required]);
            this.insuredForm.get('job').updateValueAndValidity();
          } else if (val.url == '/sava/calculator/scholarship-calculation-premium') {
            this.title = "Obračun premije na osnovu osigurane sume";
            this.infoText = "Informativna ponuda za stipendijsko osiguranje života";
            this.boolInfoText = true;
            this.insuredForm.get('job').setValidators([Validators.required]);
            this.insuredForm.get('job').updateValueAndValidity();
          } else if (val.url == '/sava/calculator/golden-autumn') {
            this.title = "Informativna ponuda za osiguranje života za slučaj smrti";
            this.infoText = "";
            this.boolInfoText = false;
            this.insuredForm.get('job').clearValidators();
            this.insuredForm.get('job').updateValueAndValidity();
          } else if (val.url == '/sava/calculator/naj-life-calculation-insured-sum') {
            this.title = "Obračun osigurane sume na osnovu premije";
            this.infoText = "Informativna ponuda za naj life osiguranje života";
            this.boolInfoText = true;
            this.insuredForm.get('job').setValidators([Validators.required]);
            this.insuredForm.get('job').updateValueAndValidity();
          } else if (val.url == '/sava/calculator/naj-life-calculation-premium') {
            this.title = "Obračun premije na osnovu osigurane sume";
            this.infoText = "Informativna ponuda za naj life osiguranje života";
            this.boolInfoText = true;
            this.insuredForm.get('job').setValidators([Validators.required]);
            this.insuredForm.get('job').updateValueAndValidity();
          } else if (val.url == '/sava/calculator/progresive') {
            this.title = "SAVA PROGRESIV";
            this.infoText = "Informativna ponuda za osiguranje života za slučaj  smrti i doživljenja vezano za jedinice investicionih fondova";
            this.boolInfoText = true;
            this.insuredForm.get('job').setValidators([Validators.required]);
            this.insuredForm.get('job').updateValueAndValidity();
          } else if (val.url == '/sava/calculator/security-cash') {
            this.title = "Obračun premije na osnovu osigurane sume";
            this.infoText = "Informativna ponuda za individualno osiguranje života sa opadajućom osiguranom sumom - Gotovinski krediti";
            this.boolInfoText = true;
            this.insuredForm.get('job').setValidators([Validators.required]);
            this.insuredForm.get('job').updateValueAndValidity();
          } else if (val.url == '/sava/calculator/vip-standard-insurance-sum') {
            this.title = "Obračun osigurane sume na osnovu premije";
            this.infoText = "Informativna ponuda za mešovito osiguranje života i mešovito osiguranje života sa pokrićem težih bolesti";
            this.boolInfoText = true;
            this.insuredForm.get('job').setValidators([Validators.required]);
            this.insuredForm.get('job').updateValueAndValidity();
          } else if (val.url == '/sava/calculator/vip-standard-premium') {
            this.title = "Obračun premije na osnovu osigurane sume";
            this.infoText = "Informativna ponuda za mešovito osiguranje života i mešovito osiguranje života sa pokrićem težih bolesti";
            this.boolInfoText = true;
            this.insuredForm.get('job').setValidators([Validators.required]);
            this.insuredForm.get('job').updateValueAndValidity();
          } else if (val.url == '/sava/calculator/vip-security-insurance-sum') {
            this.title = "Obračun osigurane sume na osnovu premije";
            this.infoText = "Informativna ponuda za osiguranje života za slučaj smrti";
            this.boolInfoText = true;
            this.insuredForm.get('job').setValidators([Validators.required]);
            this.insuredForm.get('job').updateValueAndValidity();
          } else if (val.url == '/sava/calculator/vip-security-premium') {
            this.title = "Obračun premije na osnovu osigurane sume";
            this.infoText = "Informativna ponuda za osiguranje života za slučaj smrti";
            this.boolInfoText = true;
            this.insuredForm.get('job').setValidators([Validators.required]);
            this.insuredForm.get('job').updateValueAndValidity();
          } else if (val.url == '/sava/calculator/vip-scholarship-insurance-sum') {
            this.title = "Obračun osigurane sume na osnovu premije";
            this.infoText = "Informativna ponuda za stipendijsko osiguranje života";
            this.boolInfoText = true;
            this.insuredForm.get('job').setValidators([Validators.required]);
            this.insuredForm.get('job').updateValueAndValidity();
          } else if (val.url == '/sava/calculator/vip-scholarship-premium') {
            this.title = "Obračun premije na osnovu osigurane sume";
            this.infoText = "Informativna ponuda za stipendijsko osiguranje života";
            this.boolInfoText = true;
            this.insuredForm.get('job').setValidators([Validators.required]);
            this.insuredForm.get('job').updateValueAndValidity();
          }
        }
      })
    let basic = new BasicInformations({ contractorType: this.insuranceContractorForm.value.responsiblePerson, contractorJMBG: this.insuranceContractorForm.value.jmbg, contractorAddress: this.insuranceContractorForm.value.address ? this.insuranceContractorForm.value.address.toUpperCase() : "", contractorPostalCode: this.insuranceContractorForm.value.postalCode, contractorSettlement: this.insuranceContractorForm.value.settlement ? this.insuranceContractorForm.value.settlement.toUpperCase() : "", contractorEmail: this.insuranceContractorForm.value.email, contractorAddressOfDelivery: this.insuranceContractorForm.value.addressOfDelivery ? this.insuranceContractorForm.value.addressOfDelivery.toUpperCase() : "", contractorPostalCodeOfDelivery: this.insuranceContractorForm.value.postalCodeOfDelivery, contractorSettlementOfDelivery: this.insuranceContractorForm.value.settlementOfDelivery ? this.insuranceContractorForm.value.settlementOfDelivery.toUpperCase() : "", contractorPhonenumber: this.insuranceContractorForm.value.mobile, contractorCopy: this.insuranceContractorForm.value.contractorIsInsured, insuredFirstname: this.insuredForm.value.firstname ? this.insuredForm.value.firstname.toUpperCase() : "", insuredLastname: this.insuredForm.value.lastname ? this.insuredForm.value.lastname.toUpperCase() : "", insuredJMBG: this.insuredForm.value.jmbg, insuredAddress: this.insuredForm.value.address ? this.insuredForm.value.address.toUpperCase() : "", insuredEmail: this.insuredForm.value.email, insuredMobile: this.insuredForm.value.mobile, insuredPostalCode: this.insuredForm.value.postalCode, insuredSettlement: this.insuredForm.value.settlement ? this.insuredForm.value.settlement.toUpperCase() : "", insuredJob: this.insuredForm.value.job ? this.insuredForm.value.job.toUpperCase() : "" })
    if (this.insuredForm.get('dob').value) {
      basic.data.insuredDOB = this.insuredForm.get('dob').value.split('.')[2] + '-' + this.insuredForm.get('dob').value.split('.')[1] + '-' + this.insuredForm.get('dob').value.split('.')[0];
    } else {
      basic.data.insuredDOB = ""
    }
    if (this.insuranceContractorForm.value.responsiblePerson == '1') {
      basic.data.contractorFirstname = this.insuranceContractorForm.value.responsiblePersonFirstname.toUpperCase();
      basic.data.contractorLastname = this.insuranceContractorForm.value.responsiblePersonLastname.toUpperCase();
      basic.data.contractorResponsibleName = this.insuranceContractorForm.value.legalEntityName.toUpperCase();
      basic.data.contractorID = this.insuranceContractorForm.value.idLegal;
      basic.data.contractorPIB = this.insuranceContractorForm.value.pib;
    } else {
      if (this.insuranceContractorForm.value.firstname)
        basic.data.contractorFirstname = this.insuranceContractorForm.value.firstname.toUpperCase();
      if (this.insuranceContractorForm.value.lastname)
        basic.data.contractorLastname = this.insuranceContractorForm.value.lastname.toUpperCase();
      basic.data.contractorResponsibleName = ""
      basic.data.contractorID = ""
      basic.data.contractorPIB = ""
    }
    this.basicInformationsService.addInfo(basic)


  }

  ngAfterViewInit() {
    this.digitalSubscription = this.digitalService.info$.subscribe(
      (res) => {
        if (res) {

          if (this.insuranceContractorForm.value.responsiblePerson == '1') {
            if (!this.insuranceContractorForm.value.responsiblePersonFirstname || !this.insuranceContractorForm.value.responsiblePersonLastname || !this.insuranceContractorForm.value.legalEntityName || !this.insuranceContractorForm.value.idLegal || !this.insuranceContractorForm.value.pib) {
              console.log(this.contracotrBlock)
              this.contracotrBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
              this.contractorBool = true;
            }
          } else {
            if (!this.insuranceContractorForm.value.firstname || !this.insuranceContractorForm.value.lastname) {
              console.log(this.contracotrBlock)
              this.contracotrBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
              this.contractorBool = true;
            }
          }
          if (!this.insuranceContractorForm.value.jmbg || !this.insuranceContractorForm.value.email || !this.insuranceContractorForm.value.address || !this.insuranceContractorForm.value.postalCode || !this.insuranceContractorForm.value.settlement || !this.insuranceContractorForm.value.mobile || !this.insuranceContractorForm.value.addressOfDelivery || !this.insuranceContractorForm.value.postalCodeOfDelivery || !this.insuranceContractorForm.value.settlementOfDelivery) {
            console.log(this.contracotrBlock)
            this.contracotrBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
            this.contractorBool = true;
          }
          let emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g
          // console.log(emailRegex.test(this.insuredForm.value.email))
          if (!this.insuredForm.value.firstname || !this.insuredForm.value.lastname || !this.insuredForm.value.address || !this.insuredForm.value.postalCode || !this.insuredForm.value.settlement || !this.insuredForm.value.jmbg || !this.insuredForm.value.email || !emailRegex.test(this.insuredForm.value.email) || !this.insuredForm.value.mobile) {
            console.log(this.contracotrBlock)
            this.contracotrBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
            this.insuredBool = true;
          }

          if (!this.insuredForm.value.job && this.router.url != '/sava/calculator/golden-autumn') {
            this.contracotrBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
            this.insuredBool = true;
          }

          Object.keys(this.insuranceContractorForm.controls).forEach(field => {
            const control = this.insuranceContractorForm.get(field);
            control.markAsTouched({ onlySelf: true });
          });
          this.validDraft = false;
          this.validDigital = true;
        } else {
          // console.log("Open link")
        }
      }
    )
  }

  ngOnDestroy() {
    this.digitalService.addInfo(false);
    this.saveDraftSubscription.unsubscribe();
    this.digitalSubscription.unsubscribe();
    this.removeInto.unsubscribe();
    this.fillDraftSubscription.unsubscribe();
    this.sendInfoSubscription.unsubscribe();
  }

  copyToInsured() {
    this.insuredBool = true;
    if (this.insuranceContractorForm.value.contractorIsInsured) {
      this.insuredForm.reset({ firstname: this.insuranceContractorForm.value.firstname, lastname: this.insuranceContractorForm.value.lastname, address: this.insuranceContractorForm.value.address, postalCode: this.insuranceContractorForm.value.postalCode, settlement: this.insuranceContractorForm.value.settlement, jmbg: this.insuranceContractorForm.value.jmbg, email: this.insuranceContractorForm.value.email, phonenumber: this.insuranceContractorForm.value.phonenumber, mobile: this.insuranceContractorForm.value.mobile, job: this.insuredForm.value.job })
      if (this.insuranceContractorForm.value.jmbg) {
        if (this.insuredForm.value.jmbg.length >= 7) {
          if (this.insuredForm.value.jmbg.substring(4, 5) == '0') {
            this.insuredForm.get('dob').setValue(this.insuredForm.value.jmbg.substring(0, 2) + "." + this.insuredForm.value.jmbg.substring(2, 4) + '.2' + this.insuredForm.value.jmbg.substring(4, 7))
          } else {
            this.insuredForm.get('dob').setValue(this.insuredForm.value.jmbg.substring(0, 2) + "." + this.insuredForm.value.jmbg.substring(2, 4) + '.1' + this.insuredForm.value.jmbg.substring(4, 7))
          }
        } else {
          this.insuredForm.get('dob').setValue('')
        }
      }
    } else {
      this.insuredForm.reset({ job: this.insuredForm.value.job });
    }
    this.insurendSendInfo()
  }

  copyDelivery() {
    if (this.insuranceContractorForm.value.copyToDelivery) {
      this.insuranceContractorForm.get('addressOfDelivery').setValue(this.insuranceContractorForm.value.address)
      this.insuranceContractorForm.get('postalCodeOfDelivery').setValue(this.insuranceContractorForm.value.postalCode)
      this.insuranceContractorForm.get('settlementOfDelivery').setValue(this.insuranceContractorForm.value.settlement)
    } else {
      this.insuranceContractorForm.get('addressOfDelivery').setValue('')
      this.insuranceContractorForm.get('postalCodeOfDelivery').setValue('')
      this.insuranceContractorForm.get('settlementOfDelivery').setValue('')
    }
    this.insurendSendInfo()
  }

  insurendSendInfo() {
    if (this.insuredForm.value.jmbg) {
      if (this.insuredForm.value.jmbg.length >= 7) {
        if (this.insuredForm.value.jmbg.substring(4, 5) == '0') {
          this.insuredForm.get('dob').setValue(this.insuredForm.value.jmbg.substring(0, 2) + "." + this.insuredForm.value.jmbg.substring(2, 4) + '.2' + this.insuredForm.value.jmbg.substring(4, 7))
        } else {
          this.insuredForm.get('dob').setValue(this.insuredForm.value.jmbg.substring(0, 2) + "." + this.insuredForm.value.jmbg.substring(2, 4) + '.1' + this.insuredForm.value.jmbg.substring(4, 7))
        }
      } else {
        this.insuredForm.get('dob').setValue('')
      }
    }
    if (this.insuranceContractorForm.value.copyToDelivery) {
      this.insuranceContractorForm.get('addressOfDelivery').setValue(this.insuranceContractorForm.value.address)
      this.insuranceContractorForm.get('postalCodeOfDelivery').setValue(this.insuranceContractorForm.value.postalCode)
      this.insuranceContractorForm.get('settlementOfDelivery').setValue(this.insuranceContractorForm.value.settlement)
    }
    if (this.insuranceContractorForm.value.contractorIsInsured) {
      this.insuredForm.get('firstname').setValue(this.insuranceContractorForm.value.firstname);
      this.insuredForm.get('lastname').setValue(this.insuranceContractorForm.value.lastname);
      this.insuredForm.get('jmbg').setValue(this.insuranceContractorForm.value.jmbg);
      this.insuredForm.get('address').setValue(this.insuranceContractorForm.value.address);
      this.insuredForm.get('postalCode').setValue(this.insuranceContractorForm.value.postalCode);
      this.insuredForm.get('settlement').setValue(this.insuranceContractorForm.value.settlement);
      this.insuredForm.get('email').setValue(this.insuranceContractorForm.value.email);
      this.insuredForm.get('mobile').setValue(this.insuranceContractorForm.value.mobile);
    }

    let basic = new BasicInformations({ contractorType: this.insuranceContractorForm.value.responsiblePerson, contractorJMBG: this.insuranceContractorForm.value.jmbg, contractorAddress: this.insuranceContractorForm.value.address ? this.insuranceContractorForm.value.address.toUpperCase() : '', contractorPostalCode: this.insuranceContractorForm.value.postalCode, contractorSettlement: this.insuranceContractorForm.value.settlement ? this.insuranceContractorForm.value.settlement.toUpperCase() : '', contractorEmail: this.insuranceContractorForm.value.email, contractorPIB: this.insuranceContractorForm.value.pib, contractorAddressOfDelivery: this.insuranceContractorForm.value.addressOfDelivery ? this.insuranceContractorForm.value.addressOfDelivery.toUpperCase() : '', contractorPostalCodeOfDelivery: this.insuranceContractorForm.value.postalCodeOfDelivery, contractorSettlementOfDelivery: this.insuranceContractorForm.value.settlementOfDelivery ? this.insuranceContractorForm.value.settlementOfDelivery.toUpperCase() : '', contractorPhonenumber: this.insuranceContractorForm.value.mobile, contractorCopy: this.insuranceContractorForm.value.contractorIsInsured, insuredFirstname: this.insuredForm.value.firstname ? this.insuredForm.value.firstname.toUpperCase() : '', insuredLastname: this.insuredForm.value.lastname ? this.insuredForm.value.lastname.toUpperCase() : '', insuredJMBG: this.insuredForm.value.jmbg, insuredEmail: this.insuredForm.value.email, insuredAddress: this.insuredForm.value.address ? this.insuredForm.value.address.toUpperCase() : '', insuredMobile: this.insuredForm.value.mobile, insuredPostalCode: this.insuredForm.value.postalCode, insuredSettlement: this.insuredForm.value.settlement ? this.insuredForm.value.settlement.toUpperCase() : '', insuredJob: this.insuredForm.value.job ? this.insuredForm.value.job.toUpperCase() : '' })
    if (this.insuredForm.get('dob').value) {
      basic.data.insuredDOB = this.insuredForm.get('dob').value.split('.')[2] + '-' + this.insuredForm.get('dob').value.split('.')[1] + '-' + this.insuredForm.get('dob').value.split('.')[0];
    } else {
      basic.data.insuredDOB = ""
    }
    if (this.insuranceContractorForm.value.responsiblePerson == '1') {
      basic.data.contractorFirstname = this.insuranceContractorForm.value.responsiblePersonFirstname.toUpperCase();
      basic.data.contractorLastname = this.insuranceContractorForm.value.responsiblePersonLastname.toUpperCase();
      basic.data.contractorResponsibleName = this.insuranceContractorForm.value.legalEntityName.toUpperCase();
      basic.data.contractorID = this.insuranceContractorForm.value.idLegal;
      basic.data.contractorPIB = this.insuranceContractorForm.value.pib;
    } else {
      basic.data.contractorFirstname = this.insuranceContractorForm.value.firstname.toUpperCase();
      basic.data.contractorLastname = this.insuranceContractorForm.value.lastname.toUpperCase();
      basic.data.contractorResponsibleName = ""
      basic.data.contractorID = ""
      basic.data.contractorPIB = ""
    }

    // console.log(basic)
    this.basicInformationsService.addInfo(basic)

  }

  changeTypeOfPerson(eve) {
    this.validDraft = false;
    this.validDigital = false;
    if (eve.target.value == '1') {
      this.insuredForm.reset()
      this.insuranceContractorForm.get('contractorIsInsured').setValue(false)
    }
    this.insurendSendInfo();
  }

  hideContracotr() {
    this.contractorBool = !this.contractorBool;
  }
  insuredHide() {
    this.insuredBool = !this.insuredBool;
  }

  get validInsuranceContractorForm() {
    return this.insuranceContractorForm.controls;
  }

  insuredSumAndPremiumParams: InsuranceSumAndPremium = new InsuranceSumAndPremium({
    insuranceStart: '',
    insuranceEnd: '',
    insurancePeriod: null,
    accessAge: null,
    gender: '',
    occupation: '',
    dynamicsOfPayment: '',
    cigarettesDaily: null,
    height: null,
    weight: null,
    currencyPayment: '',
    currencyPayout: '',
    indexation: '',
    methodPayment: ''
  });
  componentAdded(event) {
    // console.log(event)
    this.sendingSumAndPremiumInfo.addSumAndPremiumInfo(this.insuredSumAndPremiumParams);
  }
  componentRemoved(event) {
    // console.log(event);
    this.insuredSumAndPremiumParams.data = event.insuredSumAndPremiumForm.value;
  }

}
